const schedule = (cb: () => void): void => {
    if ('requestIdleCallback' in globalThis) {
        requestIdleCallback(cb, { timeout: 3000 });
        return;
    }
    setTimeout(cb, 1000);
};

export function prefetchCriticalRoutes(): void {
    schedule(() => {
        import('auth/features')
            .then((m) => {
                m.default.signInWithMoniepointPage();
                m.default.completeMoniepointSignIn();
                m.default.staffSignIn();
                m.default.selectBusiness();
            })
            .catch(() => console.error('Failed to prefetch from auth-ui'));

        import('dashboard/features')
            .then((m) => {
                m.default.checkLoginPage();
                m.default.homePage();
            })
            .catch(() => console.error('Failed to prefetch from dashboard-ui'));

        import('products/features')
            .then((m) => {
                m.default.itemList();
                m.default.itemTypeSelection();
                m.default.createItem();
                m.default.updateItem();
            })
            .catch(() => console.error('Failed to prefetch from products-ui'));

        import('orders/features')
            .then((m) => {
                m.default.salesList();
            })
            .catch(() => console.error('Failed to prefetch from orders-ui'));
    });
}
